<template>
    <div>
        <h3 class="mb-4">{{$t("message.myinformation_registration")}}</h3>
            <div class="table-responsive">
                <table class="table table-bordered" v-if="getParticipant.participant_type==1">
                    <thead class="table-dark">
                    <tr>
                        <th class="text-center align-middle" style="width:40px;">#</th>
                        <th class="align-middle">{{$t("message.business_type")}}</th>
                        <th class="text-center align-middle">{{$t("message.type")}}</th>
                        <th class="text-center align-middle" style="width:120px;">{{$t("message.paid_status")}}</th>
                        <th class="text-center align-middle" style="width:120px;">{{$t("message.register_date")}}</th>
                        <th class="text-center align-middle" style="width:70px;">{{$t("message.result")}}</th>
                        <th class="text-center align-middle" style="width:120px;">{{$t("message.expiration_date")}}</th>
                        <th class="text-center align-middle">{{$t("message.register_by")}}</th>
                        <th class="text-center align-middle" style="width:120px;">{{$t("message.action")}}</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in listRegister" :key="index">
                        <th style="vertical-align: middle;width: 30px;">{{index+1}}</th>
                        <td style="vertical-align: middle;">{{item.type_business_name}}</td>
                        <td class="text-center" style="vertical-align: middle;">
                            {{item.apply_for==1? "NEW" : "CPE"}}
                        </td>
                        <td class="text-center" style="vertical-align: middle;">{{item.payment_status==1? $t("message.paid") : $t("message.not_piad")}}</td>
                        <td class="text-center" style="vertical-align: middle;">{{item.created_at}}</td>
                        <td class="text-center" style="vertical-align: middle;">{{getIsPass(item.is_pass)}}</td>
                        <td class="text-center" style="vertical-align: middle;">{{item.license_expiry_date}}</td>
                        <td class="text-center" style="vertical-align: middle;">{{item.registerBy.name}}</td>
                        <td class="align-middle text-center">
                            <button v-if="item.payment_status!=1" class="btn btn-danger" @click="actionRemoveRegistration(item)"><i class="fas fa-trash"></i></button>
                            <router-link class="btn btn-primary" :to="{name:'ShowRegister', params:{id:item.id}}">
                                <i class="fas fa-edit"></i>
                            </router-link>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <table class="table table-bordered" v-if="getParticipant.participant_type==2">
                    <thead class="table-dark">
                    <tr>
                        <th class="text-center align-middle" style="width:40px;">#</th>
                        <th class="align-middle" style="width:120px;">{{$t("message.name")}}</th>
                        <th class="align-middle">{{$t("message.business_type")}}</th>
                        <!-- <th class="text-center align-middle">{{$t("message.type")}}</th> -->
                        <th class="text-center align-middle">{{$t("message.paid_status")}}</th>
                        <!-- <th class="text-center align-middle">{{$t("message.register_date")}}</th> -->
                        <th class="text-center align-middle">{{$t("message.result")}}</th>
                        <th class="text-center align-middle">{{$t("message.expiration_date")}}</th>
                        <th class="text-center align-middle" style="width:120px;">{{$t("message.action")}}</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in listRegister" :key="index">
                            <td class="text-center" style="vertical-align: middle;width: 30px;">{{index+1}}</td>
                            <td style="vertical-align: middle;  ">
                                {{item.participant.lastname + ' '  + item.participant.firstname}}
                            </td>
                            <td style="vertical-align: middle;">
                                {{item.type_business_name}}<br>
                                {{$t("message.type")}}: {{item.apply_for==1? "NEW" : "CPE"}}<br>
                                {{$t("message.register_date")}}: {{item.created_at}}
                            </td>
                            <!-- <td class="text-center">{{item.apply_for==1? "NEW" : "CPE"}}</td> -->
                            <td class="text-center" style="vertical-align: middle;">{{item.payment_status==1? 'Paid' : 'Not Piad'}}</td>
                            <!-- <td class="text-center" style="vertical-align: middle;">{{item.created_at}}</td> -->
                            <td class="text-center" style="vertical-align: middle;">{{getIsPass(item.is_pass)}}</td>
                            <td class="text-center" style="vertical-align: middle;">{{item.license_expiry_date}}√</td>
                            <td class="align-middle text-center">
                                <button class="btn btn-danger" v-if="item.payment_status!=1" @click="actionRemoveRegistration(item)"><i class="fas fa-trash"></i></button>
                                <router-link class="btn btn-primary" :to="{name:'ShowRegister', params:{id:item.id}}">
                                    <i class="fas fa-edit"></i>
                                </router-link>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
    </div>
</template>

<script>
import axios from "@/axios";
import { mapGetters } from "vuex";
export default {
    setup() {
        return {};
    },
    data() {
        return {
            listRegister: [],
        };
    },
    methods: {
        showLoader() {
            return this.$loading.show({
                container: this.$refs.formContainer,
                color: "#01B201",
                canCancel: true,
                onCancel: this.onCancelLoader
                });
        },
        async loadData(){
            let loader = this.showLoader();
            try {
                const respone = await axios.get("get-participant-register", {
                    headers: {
                        Authorization: "Bearer " + this.$store.getters.getAuthToken
                    }
                });
                if (respone.status == 200) {
                    this.listRegister = respone.data.data;
                    loader.hide();
                }
            } catch (error) {
                loader.hide();
            }
        },
        async actionRemoveRegistration(rg){
            this.$swal
            .fire({
                title: "តើអ្នកចង់ចុះឈ្មោះមែនទេ?",
                showCancelButton: true,
                confirmButtonText: `យល់ព្រម`,
                cancelButtonText: `បោះបង់`
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    let loader = this.showLoader();    
                    try {
                        const respone = await axios.delete("delete-registration/"+rg.id, {
                            headers: {Authorization: "Bearer " + this.$store.getters.getAuthToken}
                        });
                        if(respone){
                            const tmp = this.listRegister.filter( v => v.id != rg.id );
                            this.listRegister = [...tmp];
                            this.$toast.open({
                                message: this.$t("message.deleted_successfully"),
                                type: "success",
                                duration: 5000,
                                dismissible: true,
                                position: "top-right"
                            });
                        }
                        loader.hide();
                    } catch (error) {
                        this.$toast.open({
                            message: error.response.data.message,
                            type: "error",
                            duration: 5000,
                            dismissible: true,
                            position: "top-right"
                        });
                        loader.hide();
                    }
                }
            });
        }
    },
    computed :{
        ...mapGetters([
            'getParticipant'
        ]),
        getBusinessType(){
            return (t) =>{
                switch (t){
                    case '1':
                    case 1:
                        return this.$t("message.stock_business");
                    case '2':
                    case 2:
                        return this.$t("message.derivative_business");
                    case '19':
                    case 19:
                        return this.$t("message.public") + ' - ' + this.$t("message.stock_business");
                    case 20:
                    case '20':
                        return this.$t("message.public") + ' - ' + this.$t("message.derivative_business");
                    default:
                        return t;
                }
            }
        },
        getIsPass(){
            return (t) =>{
                switch (t){
                    case '1':
                    case 1:
                        return this.$t("message.pass");
                    case '2':
                    case 2:
                        return this.$t("message.fail");
                    default:
                        return '';
                }
            }
        }
    },
    created() {
        this.loadData();
    },
    mounted() {}
}
</script>

<style scoped>
    .nopadding{
        padding: 0;
        margin: 0;
    }
    .pb{
        padding-bottom: calc(100vh - 90vh);
    }
</style>